console.log('[SalesNotification] Script loaded');

class SalesNotification extends HTMLElement {
    constructor() {
        super();
        console.log('[SalesNotification] Constructor called');

        if (window.location.pathname === '/challenge') {
            console.log('[SalesNotification] Skipped: challenge page');
            return;
        }

        if (Shopify && Shopify.designMode) {
            console.log('[SalesNotification] Skipped: Shopify design mode');
            return;
        }

        this.card = this.querySelector('.sales-notification__card');
        this.closeBtn = this.querySelector('.sales-notification__close');
        this.nameEl = this.querySelector('[data-buyer-name]');
        this.locationEl = this.querySelector('[data-buyer-location]');
        this.productNameEl = this.querySelector('[data-product-name]');
        this.productPriceEl = this.querySelector('[data-product-price]');
        this.productImageEl = this.querySelector('[data-product-image]');
        this.timeEl = this.querySelector('[data-purchase-time]');

        this.isVisible = false;
        this.timer = null;
        this.hideTimer = null;

        // Parse JSON data from script tag
        this._data = null;
        const scriptTag = this.querySelector('[data-sales-notification-data]');
        if (scriptTag) {
            try {
                this._data = JSON.parse(scriptTag.textContent);
                console.log('[SalesNotification] Data parsed successfully:', this._data);
            } catch (e) {
                console.error('[SalesNotification] Failed to parse JSON data:', e);
                console.log('[SalesNotification] Raw script content:', scriptTag.textContent);
                this._data = { names: [], locations: [], products: [] };
            }
        } else {
            console.error('[SalesNotification] No data script tag found');
            this._data = { names: [], locations: [], products: [] };
        }

        this.init();
    }

    get enabled() {
        return this.dataset.enabled === 'true';
    }

    get initialDelay() {
        return parseInt(this.dataset.initialDelay || '5') * 1000;
    }

    get interval() {
        return parseInt(this.dataset.interval || '10') * 1000;
    }

    get duration() {
        return parseInt(this.dataset.duration || '5') * 1000;
    }

    get names() {
        return (this._data && this._data.names) || [];
    }

    get locations() {
        return (this._data && this._data.locations) || [];
    }

    get products() {
        return (this._data && this._data.products) || [];
    }

    get showImage() {
        return this.dataset.showImage === 'true';
    }

    get showPrice() {
        return this.dataset.showPrice === 'true';
    }

    init() {
        console.log('[SalesNotification] Init called');
        console.log('[SalesNotification] Enabled:', this.enabled);
        console.log('[SalesNotification] Products count:', this.products.length);
        console.log('[SalesNotification] Names count:', this.names.length);
        console.log('[SalesNotification] Locations count:', this.locations.length);
        console.log('[SalesNotification] Initial delay:', this.initialDelay, 'ms');

        if (!this.enabled) {
            console.log('[SalesNotification] Not enabled, stopping');
            return;
        }

        if (this.products.length === 0) {
            console.log('[SalesNotification] No products found, stopping');
            return;
        }

        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.hide();
            });
        }

        console.log('[SalesNotification] Starting timer, first popup in', this.initialDelay, 'ms');
        setTimeout(() => {
            console.log('[SalesNotification] Timer fired, showing notification');
            this.showNotification();
        }, this.initialDelay);
    }

    showNotification() {
        const names = this.names;
        const locations = this.locations;
        const products = this.products;

        if (names.length === 0 || locations.length === 0 || products.length === 0) {
            console.log('[SalesNotification] Missing data - names:', names.length, 'locations:', locations.length, 'products:', products.length);
            return;
        }

        const name = names[Math.floor(Math.random() * names.length)].trim();
        const location = locations[Math.floor(Math.random() * locations.length)].trim();
        const product = products[Math.floor(Math.random() * products.length)];
        const timeAgo = this.getRandomTimeAgo();

        console.log('[SalesNotification] Showing:', name, 'from', location, '-', product.title, product.price);

        if (this.nameEl) this.nameEl.textContent = name;
        if (this.locationEl) this.locationEl.textContent = location;
        if (this.productNameEl) {
            const link = this.productNameEl.querySelector('a');
            if (link) {
                link.textContent = product.title;
                link.href = product.url || '#';
            } else {
                this.productNameEl.innerHTML = '<a href="' + (product.url || '#') + '">' + this.escapeHtml(product.title) + '</a>';
            }
        }
        if (this.productPriceEl) {
            this.productPriceEl.textContent = product.price;
            this.productPriceEl.style.display = this.showPrice ? '' : 'none';
        }
        if (this.productImageEl) {
            if (this.showImage && product.image) {
                this.productImageEl.innerHTML = '<img src="' + product.image + '" alt="' + this.escapeHtml(product.title) + '" width="64" height="64" loading="lazy">';
                this.productImageEl.style.display = '';
            } else {
                this.productImageEl.style.display = 'none';
            }
        }
        if (this.timeEl) {
            this.timeEl.textContent = timeAgo;
        }

        this.show();

        this.hideTimer = setTimeout(() => {
            console.log('[SalesNotification] Hiding notification');
            this.hide();
            this.timer = setTimeout(() => {
                this.showNotification();
            }, this.interval);
        }, this.duration);
    }

    show() {
        console.log('[SalesNotification] Adding is-visible class');
        this.classList.add('is-visible');
        this.isVisible = true;
    }

    hide() {
        this.classList.remove('is-visible');
        this.isVisible = false;
        clearTimeout(this.hideTimer);
    }

    getRandomTimeAgo() {
        const minutes = Math.floor(Math.random() * 55) + 2;
        if (minutes < 60) {
            return minutes + ' minutes ago';
        }
        const hours = Math.floor(minutes / 60);
        return hours + (hours === 1 ? ' hour ago' : ' hours ago');
    }

    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
}

customElements.define('sales-notification', SalesNotification);
console.log('[SalesNotification] Custom element registered');
